"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyParamsOrigination = void 0;
var KeyParamsOrigination;
(function (KeyParamsOrigination) {
    KeyParamsOrigination["Registration"] = "registration";
    KeyParamsOrigination["EmailChange"] = "email-change";
    KeyParamsOrigination["PasswordChange"] = "password-change";
    KeyParamsOrigination["ProtocolUpgrade"] = "protocol-upgrade";
    KeyParamsOrigination["PasscodeCreate"] = "passcode-create";
    KeyParamsOrigination["PasscodeChange"] = "passcode-change";
})(KeyParamsOrigination = exports.KeyParamsOrigination || (exports.KeyParamsOrigination = {}));
